import { render, staticRenderFns } from "./StoreOthers.vue?vue&type=template&id=266ada47&"
import script from "./StoreOthers.vue?vue&type=script&lang=js&"
export * from "./StoreOthers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports